// extracted by mini-css-extract-plugin
export var billing = "MirrorColumnAutomationsApp-module--billing--2C2sq";
export var pricing = "MirrorColumnAutomationsApp-module--pricing--TvDbK";
export var price = "MirrorColumnAutomationsApp-module--price--5Zgt2";
export var perks = "MirrorColumnAutomationsApp-module--perks--3rWT5";
export var desc = "MirrorColumnAutomationsApp-module--desc--1YEls";
export var misc = "MirrorColumnAutomationsApp-module--misc--2xeWD";